export default __webpack_public_path__ + "assets/png/qr_redirect_logos_dark.8837cdb018aa45ee07ae7e8668068162.png";